import { number, object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  count: number().required(),
});

/**
 * NotificationCreateEvent
 *
 * - Evento emitido quando uma notificação é criada.
 */
export class NotificationCreateEvent extends CreateCommand(RealtimeEventType.NotificationCreate, SCHEMA) {}
